<template>
    <vue-typeahead-bootstrap
        v-model="query"
        :data="clients"
        highlightClass="special-highlight-class"
        @hit="selectedUser = $event"
        :serializer="item => item.nick + ' ( Dbid: ' + item.dbid + ' )'"
        :minMatchingChars="2"
        placeholder="Wpisz nick"
        inputClass="special-input-class"
        @input="searchForClients"
        style="min-width: 300px"
    >
        <template slot="suggestion" slot-scope="{ data }">
            <div class="d-flex align-items-center">
                <client :client="data" withAvatar withDetails :tooltip="false"/>
            </div>
        </template>
    </vue-typeahead-bootstrap>
</template>

<script>
import {debounce} from "lodash";
import SearchService from "@/services/search.service";

export default {
    name: "SearchClient",
    props: {
        type: String,
        select: {
            Type: String,
            Default: null
        }
    },
    data() {
        return {
            query: '',
            selectedUser: null,
            clients: [],
        }
    },
    watch: {
        selectedUser() {
            this.query = '';
            this.$emit("selected", this.selectedUser);
        }
    },
    methods: {
        searchForClients: debounce(function(){
            SearchService.search(this.query, this.type, this.select).then(
                response => {
                    this.clients = response.data;
                },
                error => {
                    console.log(error);
                }
            )
        }, 500),
    }
}
</script>

<style scoped>

</style>